<template>
    <div class="o-articles u-w100 u-py20 u-overflowYAuto">
        <div class="o-articles__inner u-container u-overflowHidden">
            <div v-if="categories.length > 0" class="o-articles__tiles u-grid">
                <Tile 
                    v-for="(category, index) in categories"
                    :key="category.slug"
                    :title="category.name"
                    :href="`/#/articles/${category.slug}`"
                    :class="getTileClass(index)" 
                />
            </div>
            <div v-if="!loading && articles.length > 0" class="o-articles__list">
                <h2 class="o-articles__title u-colorSecondary u-mt20 u-mb20">
                    {{ $t('knowledgebase.mostRecentArticles') }}
                </h2>
                <div class="o-articles__articles">
                    <Article v-for="article in articles" :key="article.id" :item="article" />
                    <div v-if="noMoreArticles" class="no-more-articles">{{ $t('knowledgebase.noMoreArticles') }}</div>
                </div>
            </div>
            <div ref="trigger" class="o-articles__trigger u-mt50"></div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import api from '../services/api';

// Components
import Tile from '../components/molecules/Tile.vue';
import Article from '../components/molecules/Article.vue';

const articles = ref([]);
const categories = ref([]);
const loading = ref(false);
const offset = ref(0);
const number = ref(8);
const noMoreArticles = ref(false);
const observer = ref(null);
const trigger = ref(null);

const tileClasses = ['-circles', '-circlesOverlap', '-badges -light', '-cards'];

const getTileClass = (index) => {
    return tileClasses[index % tileClasses.length];
};

const loadMoreArticles = async () => {
    try {
        const response = await api.get(`/articles?offset=${offset.value}&number=${number.value}`);

        if (response.data.message) {
            noMoreArticles.value = true;
        } else {
            const newArticles = response.data.map(article => ({
                id: article.id,
                image: article.image,
                title: article.title,
                date: article.date,
                categories: article.categories,
            }));
            articles.value.push(...newArticles);
            offset.value += number.value;
        }
    } catch (error) {
        console.error('Error loading articles:', error);
    }
};

const loadCategories = async () => {
    try {
        const response = await api.get('/knowledgebase-categories');
        categories.value = response.data;

    } catch (error) {
        console.error('Error loading categories:', error);
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !noMoreArticles.value) {
            loadMoreArticles();
        }
    });
    observer.value.observe(trigger.value);
};

onMounted(() => {
    loadCategories();
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});
</script>
